//https://iconduck.com/sets/svg-credit-card-and-payment-icons

import { CreditCardClientData, PaymentMethods } from 'types';
import getConfig from 'next/config';

export const getCreditCardLogo = (cardType: string) => {
  const imagePath = '/images/cards/';
  const cardToLogoMapping: {
    [key: string]: string;
  } = {
    dine: `${imagePath}diners.svg`,
    mc: `${imagePath}master.svg`,
    amex: `${imagePath}amex.svg`,
    visa: `${imagePath}visa.svg`,
    jcb: `${imagePath}jcb.svg`,
    disc: `${imagePath}discover.svg`,
    invoice: `${imagePath}invoice.svg`,
    sepa: `${imagePath}sepa.svg`,
  };
  return (
    cardToLogoMapping[cardType?.toLowerCase()] ?? `${imagePath}generic.svg`
  );
};

export const isPaymentOptionAvailable = (
  paymentMethods: PaymentMethods | undefined
) => {
  return (
    typeof paymentMethods !== 'undefined' &&
    (paymentMethods.creditCards?.length !== 0 ||
      paymentMethods.isPayByInvoiceEnabled)
  );
};

export const reorderCreditCards = (
  creditCards: CreditCardClientData[] | undefined
) => {
  if (creditCards && creditCards.length > 0) {
    const defaultCard = creditCards.filter(card => card.default);
    const nonDefaultCard = creditCards.filter(card => card.default !== true);
    return [...defaultCard, ...nonDefaultCard];
  } else {
    return creditCards;
  }
};

export const isPayByInvoiceNotEligible = (country?: string) => {
  const { publicRuntimeConfig } = getConfig();
  const payByInvoiceCountries =
    publicRuntimeConfig.PAY_BY_INVOICE_COUNTRY_LIST.split(',');

  if (country) {
    return !payByInvoiceCountries.includes(country);
  }
};
